var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"action-tracker"},[_c('tracker'),_c('leaflet')],1),_c('div',{staticClass:"disclaimer"},[_c('p',[_vm._v(_vm._s(this.disclaimer_text))])]),(_vm.total > 0)?_c('commitments',{attrs:{"count":_vm.total}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }